var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUbi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 16.9999C15.2091 16.9999 16.9999 15.2091 16.9999 12.9999C16.9999 10.7908 15.2091 8.99992 12.9999 8.99992C10.7908 8.99992 8.99992 10.7908 8.99992 12.9999C8.99992 15.2091 10.7908 16.9999 12.9999 16.9999Z",
    fill: "#1E1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9299 11.9999H25.6666V13.9999H20.9304C20.7061 15.7596 19.9038 17.3951 18.6494 18.6495C17.395 19.9039 15.7596 20.7062 13.9999 20.9306V25.6666H11.9999V20.9306C10.2403 20.7061 8.605 19.9037 7.35073 18.6493C6.09646 17.3949 5.29422 15.7596 5.06992 13.9999H0.333252V11.9999H5.06992C5.29422 10.2403 6.09646 8.6049 7.35073 7.3505C8.605 6.09611 10.2403 5.2937 11.9999 5.06922V0.333252H13.9999V5.06922C15.7596 5.2937 17.3948 6.09611 18.6491 7.3505C19.9034 8.6049 20.7056 10.2403 20.9299 11.9999ZM9.6665 17.9887C10.6532 18.648 11.8132 18.9999 12.9999 18.9999C14.5907 18.9982 16.1158 18.3655 17.2406 17.2406C18.3655 16.1158 18.9982 14.5907 18.9999 12.9999C18.9999 11.8132 18.648 10.6532 17.9887 9.6665C17.3294 8.6798 16.3924 7.91077 15.296 7.45664C14.1997 7.00252 12.9933 6.8837 11.8294 7.11521C10.6655 7.34672 9.59639 7.91816 8.75728 8.75728C7.91816 9.59639 7.34672 10.6655 7.11521 11.8294C6.8837 12.9933 7.00252 14.1997 7.45664 15.296C7.91077 16.3924 8.6798 17.3294 9.6665 17.9887Z",
    fill: "#1E1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUbi);
export default __webpack_public_path__ + "static/media/Ic_Ubi.3fc55583cd6aa7bbbe5a0253909f23b8.svg";
export { ForwardRef as ReactComponent };